import {basementAjaxGet} from "./ajax";
import axios from "axios";

export const commonPRAS = {
  tag:'web_techikAsociation',
  companyList: [],
  departmentList: [],
  account: [],
  contractCategory: [],
  contractStatus: [],
  contractType: [],
  customerType: [],
  deviceType: [],
  orderPayWay: [],
  orderStatus: [],
  qaType: [],
  deviceStatus: [],
  paymentWay: [],
  orderUsage: [],
  paymentProps: [],
  payStatus: [],
  paymentBelongTo: [],
  symbolIcon: [
    {index: 0, icon: "iconfont icon-renminbi", symbol: null, show: '人民币(¥)', short: '元'},
    {index: 0, icon: "iconfont icon-renminbi", symbol: undefined, show: '人民币(¥)', short: '元'},
    {index: 0, icon: "iconfont icon-renminbi", symbol: '￥', show: '人民币(￥)', short: '元'},
    {index: 0, icon: "iconfont icon-renminbi", symbol: '¥', show: '人民币(¥)', short: '元'},
    {index: 1, icon: "iconfont icon-meiyuan", symbol: '$', show: '美元($)', short: '美元'},
    {index: 1, icon: "iconfont icon-meiyuan", symbol: '$', show: '美元($)', short: '美元'},
    {index: 2, icon: "iconfont icon-fi-euro", symbol: '€', show: '欧元(€)', short: '欧元'},
    {index: 2, icon: "iconfont icon-fi-euro", symbol: '€', show: '欧元(€)', short: '欧元'},
    {index: 3, icon: "iconfont icon-ziyuanjrit", symbol: '₫', show: '越南盾(₫)', short: '越南盾'},
  ],
  currencySymbol: [],
  tenYears: [],
  months: [
    {id: 1, name: "一月", enName: "january", month: 1},
    {id: 2, name: "二月", enName: "february", month: 2},
    {id: 3, name: "三月", enName: "march", month: 3},
    {id: 4, name: "四月", enName: "april", month: 4},
    {id: 5, name: "五月", enName: "may", month: 5},
    {id: 6, name: "六月", enName: "june", month: 6},
    {id: 7, name: "七月", enName: "july", month: 7},
    {id: 8, name: "八月", enName: "august", month: 8},
    {id: 9, name: "九月", enName: "september", month: 9},
    {id: 10, name: "十月", enName: "october", month: 10},
    {id: 11, name: "十一月", enName: "november", month: -1},
    {id: 12, name: "十二月", enName: "december", month: 0}
  ],
  invoiceStatus: [],
  declarationSheetType: [],
  invoiceTypes: [],
  productTypeList: [
    {name: "金检机", code: "GOLD_INSPECTION", attr: "IMD", id: 1,u9:"30",short: '金'},
    {name: "重检机", code: "REINSPECTION_MACHINE", attr: "IXL", id: 2,u9:"20",short: '重'},
    {name: "X光机", code: "X_RAY_INSPECTION", attr: "TXR", id: 3,u9:"10",short: '光'},
    {name: "安检机", code: "SECURITY_INSPECTION_MACHINE", attr: "TH", id: 4,u9:"60",short: '安'},
    {name: "色选机", code: "COLOR_SELECTOR", attr: "TCS", id: 5,u9:"50",short: '色'},
    {name: "视觉机", code: "VISUAL_MACHINE", attr: "TVS", id: 6,u9:"70",short: '视'},
    // 经济型X光机（散料201系列）：U9明细机器类型为90"X光机-合肥"，账套自动预填004，工单收件组独立
    {name: "经济型X光机", code: "ECONOMY_X_RAY", attr: "TXR", id: 7,u9:"90",short: '经'}
  ],
  // 设计分配的机器部位(仅设计分配有,电气无此分类)
  // 1=主机 2=排除 3=其他
  taskMachineParts: [
    { key: "host", value: 1, label: "主机" },
    { key: "reject", value: 2, label: "排除" },
    { key: "other", value: 3, label: "其他" },
  ],
  // 工单类型:1=主工单 2=变更单 3=售后工单
  workOrderType: [
    { key: "main", value: 1, label: "主工单" },
    { key: "change", value: 2, label: "变更单" },
    { key: "afterSale", value: 3, label: "售后工单" },
  ],
  rowPermissions: [],
  useStatus: [],
  coSignatureFormType:[
    {name: "重检机会签", code: 42},
    {name: "X光机会签", code: 43},
    {name: "色选机会签", code: 44},
    {name: "金检机会签", code: 45},
    {name: "视觉机会签", code: 47},

  ],
  taxSchedules:[],
  docTypeCodes:[],
  U9Symbol: [
    {name:'人民币(¥)',code:'C001'},
    {name:'欧元(€)',code:'C005'},
    {name:'美元($)',code:'C009'},
    {name:'越南盾(₫)',code:'C010'},
  ],
  customerRegions:{},
  textMap: {
    0: '发送失败',
    1: '发送成功',
    2: '重试中',
    3: '发送中',
    4: '已取消',
    99: '待发送'
  },
  erpOptions: [
    { value: '000', label: '上海', docType: 'SO101' },
    { value: '001', label: '宸钺' ,docType: 'SO1'},
    { value: '002', label: '南阳' ,docType: 'SO102'},
    { value: '003', label: '苏州',docType: 'SO102' },
    { value: '004', label: '合肥' ,docType: 'SO102'},
    { value: '005', label: '镭曼',docType: 'SO102'},
    { value: '006', label: '因斯派克' ,docType: 'SO102'},
    { value: '007', label: '太弘' ,docType: 'SO102'},
    { value: '008', label: '新加坡' ,docType: 'SO102'},
    { value: '009', label: '越南' ,docType: 'SO102'},
  ],
  countersignTypes:{},
  countersignParseAllKeys:[],
  redisCountersignTypes: [],
  languageOptions: [
    { value: 1, label: '中文' },
    { value: 2, label: '英语' },
    { value: 3, label: '西班牙语' },
    { value: 4, label: '印地语' },
    { value: 5, label: '阿拉伯语' },
    { value: 6, label: '法语' },
    { value: 7, label: '俄语' },
    { value: 8, label: '葡萄牙语' },
    { value: 9, label: '德语' }
  ]
};
export function initFunction() {

// 获取公司列表
  axios.get('/techik/association/freeapi/getCompanyList').then((res) => {
    commonPRAS.companyList = res.data.code == 1 ? res.data.data : [];
  }).catch(() => {
    commonPRAS.companyList = [];
  });

// 获取部门列表
  axios.get("/techik/association/freeapi/getDepartmentList").then((res) => {
    commonPRAS.departmentList = res.data.code == 1 ? res.data.data : [];

  }).catch(() => {
    commonPRAS.departmentList = [];
  });

// 获取机器型号
  axios.get("/techik/association/freeapi/getTypes?length=0").then((res) => {
    commonPRAS.deviceType = res.data.code == 1 ? res.data.data : [];
  }).catch(() => {
    commonPRAS.deviceType = [];
  });

// 获取属性配置
  axios.get("/techik/association/freeapi/getProps").then((res) => {
    getYears();
    const {code, data} = res.data;
    if (code == 1) {
      const departmentDtos = JSON.parse(localStorage.getItem("departmentDtos"));
      const deptNames = departmentDtos.map(item => item.deptName);

      commonPRAS.paymentBelongTo =
        deptNames.toString().includes("财务") ||
        deptNames.toString().includes("会计") ||
        deptNames.toString().includes("出纳") ? data.paymentBelongTo :
          deptNames.some(name => name.includes("合约")) ? data.paymentBelongTo.filter(item => item.includes("合约") || item.includes("未知") || item.includes("售后")) :
            deptNames.some(name => name.includes("外贸")) ? data.paymentBelongTo.filter(item => !item.includes("合约")) :
              deptNames.some(name => name.includes("售后")) ? data.paymentBelongTo.filter(item => item.includes("售后") || item.includes("未知") || item.includes("合约")) :
                data.paymentBelongTo;

      commonPRAS.account = data.account;
      commonPRAS.contractCategory = data.contractCategory;
      commonPRAS.contractStatus = data.contractStatus;
      commonPRAS.contractType = data.contractType;
      commonPRAS.customerType = data.customerType;
      commonPRAS.orderPayWay = data.orderPayWay;
      commonPRAS.orderStatus = data.orderStatus;
      commonPRAS.qaType = data.qaType;
      commonPRAS.deviceStatus = data.deviceStatus;
      commonPRAS.paymentWay = data.paymentWay;
      commonPRAS.orderUsage = data.orderUsage;
      commonPRAS.paymentProps = data.paymentProps;
      commonPRAS.payStatus = data.payStatus;
      commonPRAS.currencySymbol = data.currencySymbol;
      commonPRAS.invoiceStatus = data.invoiceStatus;
      commonPRAS.declarationSheetType = data.declarationSheetType;
      commonPRAS.invoiceTypes = data.invoiceTypes;
      commonPRAS.rowPermissions = data.rowPermissions;
      commonPRAS.useStatus = data.useStatus;
      commonPRAS.taxSchedules = analysis(data.taxSchedules);
      commonPRAS.docTypeCodes = analysis(data.docTypeCodes);
      commonPRAS.customerRegions = data.customerRegions;
      commonPRAS.countersignTypes = data.countersignTypes;
      commonPRAS.countersignParseAllKeys = data.countersignParseAllKeys;
    } else {
      commonPRAS.account = [];
      commonPRAS.contractCategory = [];
      commonPRAS.contractStatus = [];
      commonPRAS.contractType = [];
      commonPRAS.customerType = [];
      commonPRAS.orderPayWay = [];
      commonPRAS.orderStatus = [];
      commonPRAS.qaType = [];
      commonPRAS.deviceStatus = [];
      commonPRAS.paymentWay = [];
      commonPRAS.paymentProps = [];
      commonPRAS.payStatus = [];
      commonPRAS.paymentBelongTo = [];
      commonPRAS.currencySymbol = [];
      commonPRAS.invoiceStatus = [];
      commonPRAS.declarationSheetType = [];
      commonPRAS.invoiceTypes = [];
      commonPRAS.rowPermissions = [];
      commonPRAS.useStatus = [];
      commonPRAS.taxSchedules = [];
      commonPRAS.docTypeCodes = [];
      commonPRAS.customerRegions = [];
      commonPRAS.countersignTypes = [];
      commonPRAS.countersignParseAllKeys = [];
    }
  }).catch(() => {
    commonPRAS.account = [];
    commonPRAS.contractCategory = [];
    commonPRAS.contractStatus = [];
    commonPRAS.contractType = [];
    commonPRAS.customerType = [];
    commonPRAS.orderPayWay = [];
    commonPRAS.orderStatus = [];
    commonPRAS.qaType = [];
    commonPRAS.deviceStatus = [];
    commonPRAS.paymentWay = [];
    commonPRAS.paymentProps = [];
    commonPRAS.payStatus = [];
    commonPRAS.paymentBelongTo = [];
    commonPRAS.currencySymbol = [];
    commonPRAS.invoiceStatus = [];
    commonPRAS.declarationSheetType = [];
    commonPRAS.invoiceTypes = [];
    commonPRAS.rowPermissions = [];
    commonPRAS.taxSchedules = [];
    commonPRAS.docTypeCodes = [];
    commonPRAS.customerRegions = [];
    commonPRAS.countersignTypes = [];
    commonPRAS.countersignParseAllKeys = [];
  });

  // 获取redis中的会签类型
  axios.get("/techik/countersignType/list").then((res) => {
    commonPRAS.redisCountersignTypes = res.data.code == 1 ? res.data.data : [];
  }).catch(() => {
    commonPRAS.redisCountersignTypes = [];
  });
}
function  analysis(arr){
  if(!arr||arr.length==0){
    return []
  }
  return  Object.keys(arr).map(key => ({
    value: key,
    label: arr[key]
  }));
}
export function getYears(offset) {
  const currentYear = new Date().getFullYear();
  const tenYearsArray = [];

  for (let i = 0; i < 10; i++) {
    tenYearsArray.push(currentYear - i);
  }

  if (offset && typeof offset === 'number') {
    for (let i = 1; i < offset; i++) {
      tenYearsArray.push(currentYear + i);
    }
  }

  commonPRAS.tenYears = tenYearsArray.sort((a, b) => b - a);
  return tenYearsArray.sort((a, b) => b - a);
}

export function getNextMonth() {
  const m = new Date().getMonth() + 1 + 1;
  return m > 10 ? (m === 11 ? -1 : 0) : m;
}

export function getMonthByEnName(enName) {
  const month = commonPRAS.months.filter(month => month.enName === enName.toLowerCase());
  return month && month.length > 0 ? month[0].month : null;
}
export default commonPRAS;



// WEBPACK FOOTER //
// ./src/common/constant.js